export const getLastListItemCount = (components, index) => {
    if (!isComponentStartsWithOrderedList(components[index])) {
        return 0;
    }
    else {
        return getLastListItemCountInner(components, index);
    }
};
const getLastListItemCountInner = (components, index) => {
    const allowedTypes = ['image', 'video', 'iframe', 'text', 'code', 'informative'];
    const isCompText = (comp) => comp.type === 'text';
    const getEndingLiInOlInHtml = (html) => {
        const dummy = document.createElement('div');
        dummy.innerHTML = html;
        const last = dummy.lastElementChild;
        if (last && last.tagName === 'OL') {
            return last.children.length;
        }
        return 0;
    };
    if (index === 0) {
        return 0;
    }
    const lastComp = components[index - 1];
    if (lastComp && isCompText(lastComp)) {
        const countLi = getEndingLiInOlInHtml(lastComp.value.html);
        return countLi ? countLi + getLastListItemCountInner(components, index - 1) : 0;
    }
    else if (lastComp && allowedTypes.indexOf(lastComp.type) !== -1) {
        return getEndingLiInOlInHtml(lastComp.value.html) + getLastListItemCountInner(components, index - 1);
    }
    else {
        return 0;
    }
};
export const uuid = () => {
    let d = new Date().getTime();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        // eslint-disable-next-line no-bitwise
        const r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        // eslint-disable-next-line no-bitwise
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
};
export const isComponentStartsWithOrderedList = (component) => {
    if (component.type !== 'text')
        return false;
    const dummy = document.createElement('div');
    dummy.innerHTML = component.value.html;
    const first = dummy.firstElementChild;
    return first && first.tagName === 'OL';
};
